// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";

export const ReactionBreakdownSuperAppStyles = (config: DesignSystem) => ({
    reactionBreakdownSuperAppContainer: {
        "& .cwt-reaction-breakdown-inner": {
            "& .cwt-tab-content": {
                height: "unset",
                "min-height": "280px"
            }
        }
    }
});